
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BotoesSalvarCancelar',
    emits: ['cancelou', 'salvou'],
});
